import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { TipologiaImmagine } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesTipologiaImmagine, validationSchemaTipologiaImmagine } from "./TipologiaImmagineCommon"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useTipologiaImmagineCreate } from "../../hooks/tipologie-immagini"
import TipologiaImmagineForm from "./TipologiaImmagineForm"
import { transformErrorForForm } from "../../utils/utils"

export default function TipologiaImmagineCreate() {
  const createTipologiaImmagine = useTipologiaImmagineCreate()
  const navigate = useNavigate()

  useBreadcrumbs([
    { label: "Tipologie immagini", href: "/tipologie-immagini/tipologie-immagini" },
    { label: "Creazione Tipologia Immagine" },
  ])

  const initialValues = useMemo(() => initialValuesTipologiaImmagine(), [])
  const validationSchema = useMemo(() => validationSchemaTipologiaImmagine(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova tipologia immagine</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createTipologiaImmagine.mutateAsync(values as TipologiaImmagine).then(() => {
                navigate(`/tipologie-immagini/tipologie-immagini`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TipologiaImmagineForm />
                </Container>
                <BottomFormFixed url="/tipologie-immagini/tipologie-immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
